import React from "react";
import { Link } from "react-router-dom";

const EventoCard = ({ taller }) => {
  return (
    <div className="card">
      <img src={taller.imagen} alt={taller.titulo} className="card-image" />
      <div className="card-body">
        <h3 className="card-title">{taller.titulo}</h3>
        <p className="card-date">{taller.fecha}</p>
        <p className="card-description">{taller.descripcionCorta}</p>
        <Link
          to={`/evento/${taller.slug}`}
          className="card-button"
        >
          Ver más
        </Link>
      </div>
    </div>
  );
};

export default EventoCard;